  <!-- Animated -->
            <div class="animated fadeIn">
                <!-- <h3>Analyst Panel</h3>
                <br/> -->
         
                <!--  Traffic  -->
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-body" style="min-height: 600px;">
                                <h4 class="box-title">Other File Upload</h4>
                                <!--<a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="logout()">Logout</a>-->
                           <br/>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Data Type
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="repassword" id="repassword" [(ngModel)]="title" class="form-control-sm form-control" required />
                                    </div>
                                </div>
                                <div class="row form-group" id="fileYearCont"  >
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Year
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="fileYear" id="fileYear" [(ngModel)]="fileYear" class="form-control-sm form-control" *ngIf="fileMonth!=''">
                                        	<option value="">--</option>
                                            <option value="{{yr}}" *ngFor="let yr of yearArr" >{{yr}}</option>
                                           
                                        </select>
                                        <select name="filefYear" id="filefYear" [(ngModel)]="filefYear" class="form-control-sm form-control" *ngIf="fileMonth==''">
                                        	<option value="">--</option>
                                            <option  value="{{fyr}}" *ngFor="let fyr of yearfArr"  >{{fyr}}</option>
                                        </select>
                                    </div>
                                </div>
                                
                                <div class="row form-group"  id="fileMonthCont">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Month
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="fileMonth" id="fileMonth" [(ngModel)]="fileMonth" class="form-control-sm form-control">
                                            <option value="">--</option>
                                            <option value="January">January</option>
                                            <option value="February">February</option>
                                            <option value="March">March</option>
                                            <option value="April">April</option>
                                            <option value="May">May</option>
                                            <option value="June">June</option>
                                            <option value="July">July</option>
                                            <option value="August">August</option>
                                            <option value="September">September</option>
                                            <option value="October">October</option>
                                            <option value="November">November</option> 
                                            <option value="December">December</option> 
                                        </select>
                                    </div>
                                </div>

                                <div class="row form-group" id="fileQuarterCont">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Quarter
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="fileQuarter" id="fileQuarter" [(ngModel)]="fileQuarter" class="form-control-sm form-control">
                                        	<option value="">--</option>
                                            <option value="Q1">Q1</option>
                                            <option value="Q2">Q2</option>
                                            <option value="Q3">Q3</option>
                                            <option value="Q4">Q4</option>                                            
                                        </select>
                                    </div>
                                </div>
                                 <div class="row form-group">
                                    <div class="col col-md-3"><label for="file-multiple-input" class=" form-control-label">File</label></div>
                                    <div class="col-12 col-md-9"><input type="file" id="file-multiple-input" name="file-multiple-input"  class="form-control-file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" [(ngModel)]="fileData"  ></div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"></div>
                                    <div class="col-12 col-md-9">
                                        <div class="form-actions form-group">
                                            <button type="submit" class="btn btn-primary btn-sm" (click)="uploadFile()">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div><!-- /# column -->
                </div>
                <!--  /Traffic -->
                <div class="clearfix"></div>
               
              
               
                
            </div>
            <!-- .animated -->






<div class="loaderbox" *ngIf="loaderVisibility">
    <div class="load">
        <img src="assets/images/loading.gif" alt="">
    </div>
</div>



















